import { getDegree } from "helpers";
import { Container } from "./style";
import React, { useState } from "react";

export const WeatherCityExtended = ({
  weathers = [],
  pathIcon,
  selectTemp,
}) => {
  const getDayName = (day, index) => {
    if (index === 0) return "mañana";
    return day;
  };

  return weathers.slice(1, weathers.length).map((weatherDay, index) => (
    <Container
      key={`weatherExtend${index}`}
      className={`extended-${index} grid-style`}
    >
      <div className="container-extended">
        <div className="content-one">
          <div className="part-of">
            <h2>Pronóstico para {getDayName(weatherDay.day, index)}</h2>
            <p className="w-description">{weatherDay.morning?.conditions}</p>
          </div>
          <div className="min-max">
            <div className="max-p">
              <span>{getDegree(weatherDay.max, selectTemp)}C</span>
              <p>Máxima</p>
            </div>
            <div className="min-p">
              <span>{getDegree(weatherDay.min, selectTemp)}C</span>
              <p>Mínima</p>
            </div>
          </div>
        </div>

        <div className="icon content-two">
          <figure>
            <img
              width="87"
              height="87"
              src={pathIcon(weatherDay.morning?.icon)}
              alt={weatherDay.morning?.conditions}
            />
          </figure>
        </div>
      </div>
    </Container>
  ));
};
